PF.H = class Helper
	{
	static useTrait(object, trait, use = true)
		{
		if (use === true)
			{
			if (!PF.H.hasTrait(object, trait))
				{
				new trait(object);
				}
			}
		}

	static hasTrait(object, trait)
		{
		if (object.traits !== undefined)
			{
			if (trait.name in object.traits)
				{
				return true;
				}
			}
		return false;
		}

	static isSame(v1, v2)
		{
		return v1 === 0 && v2 === 0 ? 1 / v1 === 1 / v2 : v1 !== v1 && v2 !== v2 || v1 === v2;
		}

	static randomString(length = 10)
		{
		let text = '';
		let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
		for (let i = 0; i < length; i++)
			{
			text += possible.charAt(Math.floor(Math.random() * possible.length));
			}
		return text;
		}


	static hash(target)
		{
		if (typeof target === 'object')
			{
			target = JSON.stringify(target);
			}
		let res = 0;
		let len = target.length;
		for (let i = 0; i < len; i++)
			{
			res = res * 31 + target.charCodeAt(i);
			res = res & res;
			}
		return res;
		}

	static createUUID()
		{
		return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
		}


	static isClass(func)
		{
		return typeof func === 'function' &&
			/^class\s/.test(Function.prototype.toString.call(func));
		}

	static create(classObject, ...args)
		{
		if (!PF.H.isClass(classObject))
			{
			classObject = classObject(...args);
			}
		return new classObject(...args);
		}


	static get(object, path, undefinedValue = undefined, nullValue = null, after = (v) => v)
		{
		if (path === undefined)
			{
			return undefinedValue;
			}
		let target = object;
		let parts = path.toString().split('.');
		for (let i = 0; i < parts.length; i++)
			{
			if (!(target instanceof Object))
				{
				return undefinedValue;
				}
				// if (target.dataContainer !== undefined && target.dataContainer[parts[i]] !== undefined)
				// 	{
				// 	target = target.dataContainer[parts[i]];
			// 	}
			else
				{
				target = target[parts[i]];
				}
			if (target === undefined)
				{
				return undefinedValue;
				}
			if (target === null)
				{
				return nullValue;
				}
			}
		return after(target);
		}

	static set(object, path, value)
		{
		let [target, key] = PF.H.findTarget(object, path);
		target[key] = value;
		}

	static setData(object, path, value)
		{
		let dataKeysIndex = object instanceof PF.Model ? 'options.dataKeys.' : 'dataKeys.';
		let [target, key] = PF.H.findTarget(object, path, dataKeysIndex);
		// target.set('dataContainer.' + key, value);
		if (target.set !== undefined)
			{
			target.set(dataKeysIndex + key, true);
			}
		else
			{
			target[key] = value;
			}
		target[key] = value;
		}

	static findTarget(object, path, dataKeysIndex = undefined)
		{
		let target = object;
		let parts = path.split('.');
		for (let i = 0; i < parts.length - 1; i++)
			{
			if (target[parts[i]] === undefined || target[parts[i]] === null)
				{
				if (dataKeysIndex !== undefined)
					{
					target[parts[i]] = new PF.Entity();
					target.set(dataKeysIndex + parts[i], true);
					}
				else
					{
					target[parts[i]] = {};
					}
				}
			target = target[parts[i]];
			}
		return [target, parts[parts.length - 1]];
		}

	static applyContext(string, context)
		{
		if (typeof string === "function")
			{
			return string(context);
			}
		if (typeof string !== "string")
			{
			return "";
			}

		let offset = 0;
		while (string.indexOf('@{', offset) > -1)
			{
			let begin = string.indexOf('@{', offset) + 2;
			let end = string.indexOf('}', begin);

			if (string.length - 1 > begin && begin < end)
				{
				let fullIndex = string.substring(begin, end);
				let defaultValue = '';
				let index = fullIndex;
				if (fullIndex.indexOf('|') >= 0)
					{
					[index, defaultValue] = fullIndex.split('|');
					}
				let value = PF.H.get(context, index, defaultValue, defaultValue);

				let regexp = new RegExp("\\@\\{" + fullIndex + "\\}", 'g');
				string = string.replace(`@{${fullIndex}}`, value);
				}
			offset = begin - 2;
			}

		return string;
		}

	static compareByPks(a = {}, b = {})
		{
		if (a === undefined || b === undefined || a === null || b === null)
			{
			return false;
			}
		if ((typeof a.isNull === 'function' && a.isNull() === true) && (typeof b.isNull === 'function' &&  b.isNull() === true))
			{
			return true;
			}
		if (a['#pks'] === undefined)
			{
			a['#pks'] = ['id'];
			}
		for (let i = 0; i < a['#pks'].length; i++)
			{
			let pk = a['#pks'][i];
			if (PF.H.get(a, pk) !== PF.H.get(b, pk))
				{
				return false;
				}
			}
		return true;
		};


	static decimalAdjust(type, value, exp)
		{
		if (typeof exp === 'undefined' || +exp === 0)
			{
			return Math[type](value);
			}
		value = +value;
		exp = +exp;
		if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
			{
			return NaN;
			}
		value = value.toString().split('e');
		value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
		value = value.toString().split('e');
		return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
		}

	static round(value, exp)
		{
		return PF.H.decimalAdjust('round', value, exp);
		}

	static ceil(value, exp)
		{
		return PF.H.decimalAdjust('ceil', value, exp);
		}

	static floor(value, exp)
		{
		return PF.H.decimalAdjust('floor', value, exp);
		}

	static isBigScreen()
		{
		let body = PF.Dom.Node.findOne('body');
		return body.width() > 1024;// && body.height() > 720;
		}


	};

String.prototype.splice = function (startIndex, length, insertString) {
	return this.substring(0, startIndex) + insertString + this.substring(startIndex + length);
};